import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import { FaCashRegister } from 'react-icons/fa';

// Import POS pages
import POSPage from '../POS/POSPage';

const POSModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'pos',
    title: t('modules.pos.title'),
    description: t('modules.pos.description'),
    icon: FaCashRegister,
    color: '#198754',
    menuItems: [
      {
        path: '/pos-module',
        icon: FaCashRegister,
        label: t('nav.pos')
      }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        {/* POS main page */}
        <Route path="/" element={<POSPage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default POSModule;
